require('bootstrap');
require('angular');
require('angular-sanitize');
require('./ThemeFunctions');
require('./modals-data-2804');
require('./animations-data');
require('../vendor/fm_subscription/js/PwnFMSubscriptionApp');
require('../less/agency.less');

module.exports = angular.module('WstroneniebaApp',['ngSanitize', 'ThemeFunctions', 'ModalsData', 'AnimationsData', 'PwnFMSubscriptionApp'])
.directive('modalThumbnails', ['modals_data', 'modalService', function( modals_data, modalService ) {
    return {
        templateUrl: 'tpl/modal-thumbnails.html',
        controller: ['$scope', '$element', '$attrs', function( $scope, $element, $attrs ) {
            $scope.modals_data = modals_data;
            $scope.setCurrentModal = function(modal_id) {
                modalService.setCurrentModal( modal_id );
            }
        }],
        scope: {}
    }
}])
.directive('animationThumbnails', ['animations_data', function( animations_data ) {
    return {
        templateUrl: 'tpl/animation-thumbnails.html',
        controller: ['$scope', '$element', '$attrs', function( $scope, $element, $attrs ) {
            $scope.animations_data = animations_data;
        }],
        scope: {}
    }
}])
.directive('modalWindow', ['modalService', 'modals_data', function( modalService, modals_data ) {
    return {
        templateUrl: 'tpl/modal-windows.html',
        controller: ['$scope', '$element', '$attrs', function( $scope, $element, $attrs ) {
            $scope.modals_data = modals_data;
            $scope.modalService = modalService;
        }],
        scope: {}
    }
}])
.directive('downloadGiftBut',
    function() {
        return {
            link: function( scope, element, attrs ) {
                element.on('click', function() {
                    jQuery('#fmSubscriptionEmailModal').modal('show');
                })
            }
        }
    }
);


//////////////////
// WEBPACK FOOTER
// ./jssrc/wstronenieba-app.js
// module id = 12
// module chunks = 0